import calcUnadjCurrentSkill from '../helpers/calcUnadjCurrentSkill'
import calcSkillIncrease from '../helpers/calcSkillIncrease'
import getCharacterSkill from '../helpers/getCharacterSkill'
import calcCurrentSkill from '../helpers/calcCurrentSkill'
import calcBaseSkill from '../helpers/calcBaseSkill'
import isCappedTicks from '../helpers/isCappedTicks'
import isCappedSkill from '../helpers/isCappedSkill'
import calcMaxTicks from '../helpers/calcMaxTicks'
//------------------------------
// calc (specific) skill values
//------------------------------
export default function calcSkillValues({ skill, character, max_skill }) {
  // console.log('---------------------------------')
  // console.log('IN calcSkillValues for skill: ' + skill.name)
  // console.log('SKILL >>>> = ', skill)

  let parent_skill = null
  //======================================
  // 0. GET PARENT SKILL (ONCE) IF APPROP
  //======================================
  if (skill.parent_name) {
    parent_skill = getCharacterSkill(character.skills, skill.parent_name)
    // console.log('parent_name = ', skill.parent_name)
  }
  //====================================
  // A. CALC SKILL BASE
  //====================================
  // console.log('--- CALC BASE SKILL: ' + skill.name + ' ---')
  //---------------------------------------
  // if skill has parent - use parent base
  //---------------------------------------
  if (parent_skill) {
    skill.base = parent_skill.base
  } else {
    //----------------
    // else calc base
    //----------------
    skill.base = calcBaseSkill(character, skill)
  }
  // console.log('skill.base = ', skill.base)
  //====================================
  // B. CALC CUR SKILL
  //====================================
  // console.log('--- CALC CUR SKILL: ' + skill.name + ' ---')
  //--------------
  // set cur parm
  //--------------
  const cur_parm = {
    adjs_tot: skill.adjs_tot,
  }
  //----------------------------------------------------------------------------------------
  // if skill has parent - use parent cur instead of child base (will be no ticks/training)
  //----------------------------------------------------------------------------------------
  if (parent_skill) {
    cur_parm['base'] = parent_skill.cur
  } else {
    cur_parm['base'] = skill.base
    cur_parm['ticks'] = skill.ticks
    cur_parm['training'] = skill.training
  }
  // console.log('cur_parm for cur skill calc = ', cur_parm)
  //-------------------
  // go calc cur skill
  //-------------------
  skill.cur = calcCurrentSkill(cur_parm)
  // console.log('skill.cur = ', skill.cur)
  //====================================
  // C. CALC UNADJ CUR SKILL
  //====================================
  // console.log('--- CALC UNADJ CUR SKILL: ' + skill.name + ' ---')
  //--------------------------------------------
  // if skill has parent - use parent cur no adj
  //---------------------------------------------
  if (parent_skill) {
    skill.cur_no_adjs = parent_skill.cur_no_adjs
  } else {
    //------------------------
    // else calc cur no unadj
    //------------------------
    //--------------
    // set unadj parm
    //--------------
    const unadj_parm = {
      base: skill.base,
      ticks: skill.ticks,
      training: skill.training,
    }
    // console.log('parm for unadj cur skill calc = ', unadj_parm)
    //-------------------------
    // go calc unadj cur skill
    //-------------------------
    skill.cur_no_adjs = calcUnadjCurrentSkill(unadj_parm)
  }
  // console.log('skill.cur_no_adjs = ', skill.cur_no_adjs)
  //====================================
  // D. CALC SKILL INCREASE
  //====================================
  // console.log('--- CALC SKILL INCREASE: ' + skill.name + ' ---')
  //-----------------------------------------------------------
  // if skill has parent - increase = zero (child not tickable)
  //------------------------------------------------------------
  if (parent_skill) {
    skill.incr_percent = 0
  } else {
    //----------------
    // else calc incr
    //----------------
    //---------------
    // set incr parm
    //---------------
    const incr_parm = {
      kb: character.know_bonus_percent,
      cur_no_adjs: skill.cur_no_adjs,
    }
    // console.log('parm for skill incr calc = ', incr_parm)
    //--------------------
    // go calc skill incr
    //--------------------
    skill.incr_percent = calcSkillIncrease(incr_parm)
  }
  // console.log('skill.incr_percent = ', skill.incr_percent)
  //====================================
  // E. CALC MAX TICKS
  //====================================
  // console.log('--- CALC MAX TICKS: ' + skill.name + ' ---')
  //-------------------------------------------------------------
  // if skill has parent - ticks max = zero (child not tickable)
  //-------------------------------------------------------------
  if (parent_skill) {
    skill.ticks_max = 0
  } else {
    //---------------------
    // else calc ticks max
    //---------------------
    //---------------
    // set max parm
    //---------------
    // const max_parm = {
    //   base: skill.base,
    //   training: skill.training,
    // }
    const max_parm = {
      base: skill.base,
      training: skill.training,
      ticks: skill.ticks,
      max_skill: max_skill,
    }
    // console.log('parm for max ticks calc = ', max_parm)
    //-------------------
    // go calc max ticks
    //-------------------
    skill.ticks_max = calcMaxTicks(max_parm)
  }
  // console.log('skill.ticks_max = ', skill.ticks_max)
  //====================================
  // F. DETERMINE CAPPED TICKS
  //====================================
  // console.log('--- DETERMINE CAPPED TICKS: ' + skill.name + ' ---')
  //-----------------------------------------------------------------
  // if skill has parent - capped ticks = false (child not tickable)
  //-----------------------------------------------------------------
  if (parent_skill) {
    skill.capped_ticks = false
  } else {
    //----------------------------
    // else detemine capped ticks
    //----------------------------
    //---------------
    // set capped parm
    //---------------
    const capped_parm = {
      ticks: skill.ticks,
      max: skill.ticks_max,
    }
    // console.log('parm for capped ticks determination = ', capped_parm)
    //---------------------------
    // go determine capped ticks
    //---------------------------
    skill.capped_ticks = isCappedTicks(capped_parm)
  }
  // console.log('skill.capped_ticks = ', skill.capped_ticks)
  //====================================
  // G. DETERMINE CAPPED SKILL
  //====================================
  // console.log('--- DETERMINE CAPPED SKILL: ' + skill.name + ' ---')
  //-----------------------------------------------------------------
  // if skill has parent - capped skill = false (child not tickable)
  //-----------------------------------------------------------------
  if (parent_skill) {
    skill.capped_skill = false
  } else {
    //-----------------------------
    // else determine capped skill
    //-----------------------------
    //---------------
    // set capped parm
    //---------------
    const capped_parm = {
      cur_no_adjs: skill.cur_no_adjs,
      max: max_skill,
    }
    // console.log('parm for capped skill determination = ', capped_parm)
    //---------------------------
    // go determine capped skill
    //---------------------------
    skill.capped_skill = isCappedSkill(capped_parm)
  }
  // console.log('skill.capped_skill = ', skill.capped_skill)
  //----------------------
  // return updated skill
  //----------------------
  return skill
}
